import ChatbotGeneralCase from './ChatbotGeneralCase';

export default ChatbotGeneralCase;